{
  "id": "tokyo-night",
  "name": "Tokyo",
  "description": "Tokyo Night (dark) and Tokyo Day (light) — folke/tokyonight.nvim",
  "colors": {
    "light": {
      "primary": "#2e7de9",
      "secondary": "#9854f1",
      "positive": "#587539",
      "negative": "#f52a65",
      "warning": "#8c6c3e",
      "important": "#b15c00",
      "light": "#e1e2e7",
      "dark": "#1a1b26",
      "surface": "#d0d5e3",
      "darksurface": "#c1c9df",
      "white": "#d0d5e3"
    },
    "dark": {
      "primary": "#7AA2F7",
      "secondary": "#BB9AF7",
      "positive": "#9ECE6A",
      "negative": "#F7768E",
      "warning": "#E0AF68",
      "important": "#FF9E64",
      "light": "#D5D6DB",
      "dark": "#1A1B26",
      "surface": "#E1E2E7",
      "darksurface": "#24283B",
      "white": "#FFFFFF"
    }
  }
}
